import { render } from "./ActionExpandedListItemTransferTokens.vue?vue&type=template&id=845bf412"
import script from "./ActionExpandedListItemTransferTokens.vue?vue&type=script&lang=ts"
export * from "./ActionExpandedListItemTransferTokens.vue?vue&type=script&lang=ts"
script.render = render

export default script